/** Portal analytics overlays to document.body so they sit above the fixed sidebar (z-index 1001). */
export const ANALYTICS_OVERLAY_Z_INDEX = 1050;

export const getAnalyticsModalContainer = () => document.body;

/** Keeps scoped dashboard styles on modal content when portaled outside .main-wrapper */
export const analyticsModalOverlayProps = {
  getContainer: getAnalyticsModalContainer,
  wrapClassName: "analytics-dashboard-root",
  zIndex: ANALYTICS_OVERLAY_Z_INDEX,
};

export const analyticsDrawerOverlayProps = {
  getContainer: getAnalyticsModalContainer,
  rootClassName: "analytics-dashboard-root",
  zIndex: ANALYTICS_OVERLAY_Z_INDEX,
};
